<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.providerRequestInfo')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body py-5 px-5">
                    <div class="row mx-3">
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shortPage.companyName')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.name}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.enterpriseUnifiedNumber')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.enterpriseUnifiedNumber}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.accreditationNumber')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.accreditationNumber}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.taxNumber')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.taxNumber}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.email')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.email}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.country')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.country}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.city')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.city}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.district')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.district}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.streetName')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.streetName}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.buildingNumber')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.buildingNumber}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.postalCode')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.postalCode}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.additionalNumber')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.additionalNumber}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.otherIdentifier')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.otherIdentifier}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.expireDate')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.expireDate}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.vatNumber')}}</label>
                            <h4 class="user_info_txt">{{providerRequest.vatNumber}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('dashboardPage.status')}}</label>
                            <h4 class="user_info_txt" :class="'status-' + providerRequest.providerRequestStatus">{{GetProviderRequestStatus(providerRequest.providerRequestStatus)}}</h4>
                        </div>
                        <div class="col-sm-4">
                            <label class="user_info_header">{{$t('shared.isVirtualOperator')}}</label>
                            <template v-if="canEditVirtualOperator">
                                <div class="mt-1">
                                    <input type="checkbox"
                                           class="mx-1"
                                           v-model="providerRequest.isVirtualOperator"
                                           :disabled="providerRequest.isVirtualOperator"
                                           @change="onVirtualOperatorToggle" />
                                </div>
                            </template>
                            <h4 class="user_info_txt" v-else>{{ providerRequest.isVirtualOperator ? $t('shared.yes') : $t('shared.no') }}</h4>
                        </div>
                        <div class="col-sm-4" v-if="providerRequest.isVirtualOperator || canEditVirtualOperator">
                            <label class="user_info_header">{{$t('shared.virtualOperator')}}</label>
                            <template v-if="canEditVirtualOperator">
                                <div class="form-group mb-0 mt-1">
                                    <v-select v-model="providerRequest.virtualOperatorId"
                                              :items="operatorOptions"
                                              item-text="name"
                                              item-value="id"
                                              :label="$t('shared.selectOperator')"
                                              :disabled="!providerRequest.isVirtualOperator"
                                              solo
                                              attach>
                                    </v-select>
                                </div>
                            </template>
                            <h4 class="user_info_txt" v-else>{{ virtualOperatorDisplayName }}</h4>
                        </div>
                        <div class="col-md-12 mt-3">
                            <label class="user_info_header">{{$t('shared.attachmentList')}}</label>
                            <ul class="list-group list_Sender scrollbar">
                                <template
                                    v-if="providerRequest.providerRequestAttachments && providerRequest.providerRequestAttachments.length > 0">
                                    <li class="list-group-item" v-for="att in providerRequest.providerRequestAttachments"
                                        :key="att.id || att.fileName">
                                        <span class="box-name w-100">{{ att.fileName }}</span>
                                        <span class="box-name w-100">{{ labelFor(att.attachmentType) }}</span>
                                        <i class="fas fa-download" @click="DownloadAttachment(att)"></i>
                                    </li>
                                </template>
                                <li class="list-group-item" v-else>
                                    {{$t('shared.noAttachments')}}
                                </li>
                            </ul>
                        </div>
                        <hr class="w-100 mt-4" />
                        <div class="col-md-12">
                            <label class="card_header_text">{{$t('shared.users')}}</label>
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th class="text-center">{{$t('shared.userName')}}</th>
                                            <th class="text-center">{{$t('shared.userEmail')}}</th>
                                            <th class="text-center">{{$t('shared.phoneNumber')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-center">{{providerRequest.username}}</td>
                                            <td class="text-center">{{providerRequest.useremail}}</td>
                                            <td class="text-center">{{providerRequest.mobile}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-between align-items-center mt-4 mr-2">
                                <div class="col-auto mr-2" v-if="canEditVirtualOperator">
                                    <button class="btn btn-outline-danger mr-2 ur-action-btn"
                                            @click="showRejectDialog">
                                        {{$t('dashboardPage.reject')}}
                                    </button>
                                    <button class="btn btn-primary ur-action-btn"
                                            @click="showapproveDialog">
                                        {{$t('dashboardPage.Approve')}}
                                    </button>
                                </div>
                                <div class="col-auto mr-2">
                                    <router-link to="/Providers/ProviderRequests" tag="a" class="link_danger router-link-active">{{$t('shared.back')}}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card class="ur-confirm-dialog">
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideapproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p>{{$t('shared.approveProviderRequestInputText')}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <button class="btn btn-outline-secondary px-5 py-2" @click="hideapproveDialog">
                                {{$t('shared.no')}}
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="approve">{{$t('shared.yes')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <v-dialog v-model="rejectdialog" persistent width="554">
        <v-card class="ur-confirm-dialog">
            <v-card-title class="headline grey lighten-2" primary-title>
                {{$t('dashboardPage.reject')}}
                <div class="close__dialog">
                    <i class="fas fa-times" @click="hideRejectDialog"></i>
                </div>
            </v-card-title>
            <v-card-text>
                <p class="text-center">{{$t('shared.rejectProviderRequestInputText')}}</p>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="form-group mb-0">
                            <label>{{$t('dashboardPage.rejectreason')}}</label>
                            <input class="form-control" v-model="rejectResone" type="text" />
                        </div>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="form-row justify-content-end align-items-center">
                    <div class="col-auto mx-3">
                        <button class="btn btn-outline-secondary px-5 py-2" @click="hideRejectDialog">
                            {{$t('shared.no')}}
                        </button>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-danger px-5 py-2"
                                :disabled="!rejectReasonIsValid"
                                @click="reject">{{$t('shared.yes')}}</button>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
